// extracted by mini-css-extract-plugin
module.exports = {"titleSignature":"RightPanel_titleSignature__2mjTe"};